import { useEffect, useState } from 'react';

/**
 * CSS media query ile eşleşmeyi dinleyen hook.
 * Ekran boyutu değiştikçe otomatik güncellenir.
 *
 * @param query - CSS media query string'i
 * @returns Media query ile eşleşip eşleşmediğini belirten boolean değer
 *
 * @example
 * ```tsx
 * const isMobile = useMediaQuery('(max-width: 767.98px)');
 * const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991.98px)');
 * const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
 *
 * return isMobile ? <MobileView /> : <DesktopView />;
 * ```
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

    mediaQuery.addEventListener('change', handler);
    setMatches(mediaQuery.matches);

    return () => mediaQuery.removeEventListener('change', handler);
  }, [query]);

  return matches;
};

const MOBILE_BREAKPOINT = '(max-width: 767.98px)';

export const useIsMobile = (): boolean => useMediaQuery(MOBILE_BREAKPOINT);
